import React, { Fragment } from 'react';
import { Show, TextField, DateField, useTranslate } from 'react-admin';
import { Typography, makeStyles } from '@material-ui/core';
import { LinkField, AmountField } from '../../components/fields';
import { GridShowLayout, Grid } from '../../components/wrapper';
import AccountingAccountShowActions from './AccountingAccountShowActions';
import AccountingAccountItemList from '../accountingAccountItems/AccountingAccountItemList';
import AccountingAccountTransferList from '../accountingAccountTransfers/AccountingAccountTransferList';

const useStyles = makeStyles({
	titles: {
		marginTop: 10,
		marginBottom: 20
	},
	show: {
		marginBottom: 24
	},
	list: {
		marginBottom: 24
	}
});

const AccountingAccountShow = ({ id, ...remainingProps }) => {
	const classes = useStyles();
	const translate = useTranslate();
	return (
		<Fragment>
			<Show id={id} {...remainingProps} actions={<AccountingAccountShowActions />} className={classes.show}>
				<GridShowLayout>
					<Grid container>
						<Grid item xs>
							<TextField source="id" />
							<DateField source="creationDateTime" showTime={true} />
							<LinkField source="owner" />
							<AmountField
								label="resources.accountingAccounts.labels.accountBalance"
								source="accountBalance"
								/>
							<TextField source="accountType.description" />
						</Grid>
						<Grid item xs>
							<TextField source="accountType.accountTypeCode" />
							<TextField source="currencyCode" />
							<TextField source="qualifier" />
							<TextField source="trafficType" />
						</Grid>
					</Grid>
				</GridShowLayout>
			</Show>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.accountingAccountItems.name')}
			</Typography>
			<AccountingAccountItemList
				{...remainingProps}
				hideAccountIdFilter={true}
				perPage={5}
				title=" "
				basePath={'/accountingAccountItems'}
				resource={"accountingAccountItems"}
				filter={{ accountId: id }}
				className={classes.list}
				/>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.accountingAccountTransfers.name')}
			</Typography>
			<AccountingAccountTransferList
				{...remainingProps}
				hideAccountIdFilter={true}
				perPage={5}
				title=" "
				basePath={'/accountingAccountTransfers'}
				resource={"accountingAccountTransfers"}
				filter={{ accountId: id }}
				className={classes.list}
				/>

		</Fragment>
	);
};

export default AccountingAccountShow;
